import api from '../config/api';

export const employeeService = {
    /**
     * Get employee profile
     * @returns {Promise}
     */
    getProfile: async () => {
        const response = await api.get('/employee/profile');
        return response.data;
    },

    /**
     * Update employee profile
     * @param {Object|FormData} data
     * @returns {Promise}
     */
    updateProfile: async (data) => {
        // The interceptor will handle FormData Content-Type automatically
        const response = await api.post('/employee/profile', data);
        return response.data;
    },

    /**
     * Upload CV
     * @param {File} file
     * @returns {Promise}
     */
    uploadCv: async (file) => {
        const formData = new FormData();
        formData.append('cv', file);
        const response = await api.post('/employee/upload-cv', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    /**
     * Get skills
     * @returns {Promise}
     */
    getSkills: async () => {
        const response = await api.get('/employee/my-skills');
        return response.data;
    },

    /**
     * Sync skills
     * @param {Array<number>} skillIds
     * @returns {Promise}
     */
    syncSkills: async (skillIds) => {
        const response = await api.post('/employee/sync-skills', { skills: skillIds });
        return response.data;
    },

    /**
     * Get education history
     * @returns {Promise}
     */
    getEducationHistory: async () => {
        const response = await api.get('/employee/education-history');
        return response.data;
    },

    /**
     * Add education history
     * @param {Object} data
     * @returns {Promise}
     */
    addEducationHistory: async (data) => {
        const response = await api.post('/employee/education-history', data);
        return response.data;
    },

    /**
     * Update education history
     * @param {number} id
     * @param {Object} data
     * @returns {Promise}
     */
    updateEducationHistory: async (id, data) => {
        const response = await api.put(`/employee/education-history/${id}`, data);
        return response.data;
    },

    /**
     * Delete education history
     * @param {number} id
     * @returns {Promise}
     */
    deleteEducationHistory: async (id) => {
        const response = await api.delete(`/employee/education-history/${id}`);
        return response.data;
    },

    /**
     * Get job history
     * @returns {Promise}
     */
    getJobHistory: async () => {
        const response = await api.get('/employee/job-history');
        return response.data;
    },

    /**
     * Add job history
     * @param {Object} data
     * @returns {Promise}
     */
    addJobHistory: async (data) => {
        const response = await api.post('/employee/job-history', data);
        return response.data;
    },

    /**
     * Update job history
     * @param {number} id
     * @param {Object} data
     * @returns {Promise}
     */
    updateJobHistory: async (id, data) => {
        const response = await api.put(`/employee/job-history/${id}`, data);
        return response.data;
    },

    /**
     * Delete job history
     * @param {number} id
     * @returns {Promise}
     */
    deleteJobHistory: async (id) => {
        const response = await api.delete(`/employee/job-history/${id}`);
        return response.data;
    },
};


